import {User} from 'interfaces';
import {track as trackFacebook} from 'marketplace/utilities/facebook-pixel';
import {track as trackOptimizely} from 'marketplace/utilities/optimizely';
import {setIsSubscribed} from 'marketplace/utilities/subscription-cookie';
import {ContactTrackingData} from '../../types';

export interface ContactApiOptions {
  authenticityToken: string;
  formValues: {
    message: string;
    finances: boolean;
    subscribe: boolean;
    introduction: string;
  };
  user?: User;
  contactTracking: ContactTrackingData;
}

const CONTACT_URI = 'contact';

const headers = {
  'Content-Type': 'application/json',
};

const ANALYTICS = {
  fbqEvent: 'ContactSellerSuccess',

  gaContactAction: 'success',
  gaContactCategory: 'contact_seller',

  gaSubscribeLabel: 'email',
  gaSubscribeAction: 'contact_form',
  gaSubscribeCategory: 'exchange_subscribe',

  optimizelyEvent: '',
};

export async function contactSeller({
  authenticityToken,
  formValues,
  contactTracking,
}: ContactApiOptions) {
  const body = JSON.stringify({
    /* eslint-disable-next-line babel/camelcase */
    authenticity_token: authenticityToken,
    contact: formValues,
  });

  try {
    const response = await fetch(`${location.pathname}/${CONTACT_URI}`, {
      body,
      headers,
      method: 'POST',
      credentials: 'same-origin',
    });

    if (response.ok) {
      contactSuccessTracking(formValues.subscribe, contactTracking);
      return true;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

let trackGoogleEvent;
async function trackGoogle(...args) {
  if (typeof window !== 'undefined') {
    const analytics = await import('@shopify/marketing-assets/dist/javascripts/global/analytics');
    const config = await import('@shopify/marketing-assets/dist/javascripts/global/config');
    if (!trackGoogleEvent) {
      config.set('customGoogleAnalyticsNamespace', '_exchange');
      trackGoogleEvent = analytics.default;
    }
    return trackGoogleEvent.track(...args);
  }
  return Promise.reject();
}

export function contactSuccessTracking(subscribe: boolean, contactTracking: ContactTrackingData) {
  const {fbqEvent, optimizelyEvent, gaContactCategory, gaContactAction} = ANALYTICS;

  trackGoogle(gaContactCategory, gaContactAction, contactTracking.gaLabel);
  trackFacebook(fbqEvent);
  trackOptimizely(optimizelyEvent);

  if (subscribe) {
    const {gaSubscribeAction, gaSubscribeCategory, gaSubscribeLabel} = ANALYTICS;
    trackGoogle(gaSubscribeCategory, gaSubscribeAction, gaSubscribeLabel);
    setIsSubscribed(true);
  }

  return true;
}
